module.exports = "/_next/static/images/43cfc90d87f884bb24519b9337fe3202-prepayment_add.png.webp";